"use client";

import { usePathname } from "next/navigation";

// Re-keys on route change so children re-mount and replay the fade-up.
export default function PageFade({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return (
    <div key={pathname} className="page-fade flex flex-col gap-4 lg:gap-6">
      {children}
    </div>
  );
}
